import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: 'AIzaSyBfJum1rNamKcVuBLOhKP0VITxJFBFUN3k',
  authDomain: 'ovr-v2.firebaseapp.com',
  databaseURL: 'https://ovr-v2.firebaseio.com',
  projectId: 'ovr-v2',
  storageBucket: 'ovr-v2.appspot.com',
  messagingSenderId: '797287754825'
};
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
  timestampsInSnapshots: true
}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')

export {
  db,
  auth,
  currentUser,
  usersCollection
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js